import React from 'react'
import "./CardDetails.css"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router';
import { dateTimeFormat } from '../utils/common';
import { Tooltip } from '@mui/material';

const CardDetails = ({pa}) => {

    const navigate = useNavigate()

    return (
        <>        
            <div className="card-details" onClick={() => navigate(`/open/${pa.ticketId}`)}>
            <div className={pa.priority === 'High' && "card red" || pa.priority==='Low' && "card yellow" || pa.priority==='Medium' && "card green"}>
            <div className="card-top">
                <span>{pa.ticketId}</span>
                <OpenInNewIcon className='icon-new'style={{color:"#3169bd"}}/>
            </div>
            <p className="card-para">
           {pa.title && pa.title.length > 30 ? (
           <Tooltip title={pa.title}>
          <span>{pa.title.substring(0, 27).concat('...')}</span>
         </Tooltip>
          ) : (
          pa.title
           )}
          </p>
            <div className="card-mid">
                <div className='card-mid-sub-item'>
                <span>
                    Status
                    {pa.status && pa.status?.length > 15 ? <Tooltip title={pa.status}><p className="status-para">{pa.status?.substring(0, 12)?.concat('...')}</p></Tooltip> : <p className="status-para">{pa.status}</p>}
                </span>
                </div>
                <div className='card-mid-sub-item' style={{width: '100%'}}>
                <span>
                    Project
                    <p>
                    {pa.projectTag}
                    </p>
                </span>
                </div>
                <div className='card-mid-sub-item'>
                <span>
                    Category
                    {pa.category && pa.category?.length > 15 ? <Tooltip title={pa.category}><p>{pa.category?.substring(0, 12)?.concat('...')}</p></Tooltip> : <p>{pa.category}</p>}
                </span>
                </div>
            </div>
            <div className="card-bottom">
                <div className='card-mid-sub-item'>
                    <span>
                        Created Date
                        <p>
                        {dateTimeFormat(pa.submittedDate)}
                        </p>
                    </span>
                </div>
                <div className='card-mid-sub-item' style={{width: '60%'}}>
                    <span>
                        Due Date
                        <p>
                        {dateTimeFormat(pa.dueDate, true)}
                        </p>
                    </span> 
                </div>
            </div>
        </div>
        </div>   
     </>       
    )
}

export default CardDetails
